// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"subtitle_subtitle__NxfF5","icon":"subtitle_icon__1LCDv","text":"subtitle_text__oMMUS","spacer":"subtitle_spacer__z973q"};